<template>
  <a @click="seasonIdChange">
    {{ seasonDesc }}
  </a>
</template>

<script setup lang="ts">
  import {computed} from 'vue';
  import {COLUMN_FORMATTERS} from '@/services/columns/columns.base';
  import {useContextStore} from '@/store/context.store';
  import {RendererProps} from '@/components/stats/renderer/renderer.model';

  const props = defineProps<{
    props: RendererProps;
  }>();

  const context = useContextStore();

  const seasonId = computed(() => props.props.value ? String(props.props.value) : '');
  const seasonDesc = computed(() => seasonId.value ? COLUMN_FORMATTERS.formatSeason(props.props) : '');

  function seasonIdChange() {
    if (seasonId.value) {
      context.setFocusSeasonId(seasonId.value);
    }
  }
</script>
